export function fetchLeads(){
    return { type: 'LEADS/FETCH' }
}
export function addLead(lead){
    return { type: 'LEADS/ADD', lead}
}